import { Component, OnInit, AfterViewChecked, Input, Inject, Host, ElementRef, PLATFORM_ID } from '@angular/core';
import { PageScrollInstance, PageScrollService } from 'ngx-page-scroll-core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { SectionControlSet } from 'src/app/web-generator/template-generator/entity/section';

@Component({
  selector: 'app-index-controller',
  templateUrl: './index-controller.component.html',
  styleUrls: ['./index-controller.component.scss']
})
export class IndexControllerComponent implements OnInit, AfterViewChecked {
  /** 區塊設定資料 */
  protected _data: SectionControlSet;
  /** 區塊設定資料 */
  @Input() set data(d: SectionControlSet) {
    this._data = d;
  }
  /** 區塊設定資料 */
  get data() { return this._data; }
  configuredSiteModules$ = new BehaviorSubject<Array<string>>(null);
  get configuredSiteModules(): Array<string> {
    return this.configuredSiteModules$.getValue();
  }
  set configuredSiteModules(modules: Array<string>) {
    this.configuredSiteModules$.next([...modules]);
  }
  /** 允許移動區塊，預設為真 */
  @Input() canMoveSection = true;
  /** 允許切換區塊顯示，預設為真 */
  @Input() canToggleVision = true;
  /** 允許增加區塊 */
  @Input() canAddSection = false;
  /** 允許刪除區塊 */
  @Input() canDelSection = false;
  /** 允許切換區塊Wow動畫，預設為真 */
  @Input() canToggleWow = true;
  pageScrollInstance: PageScrollInstance;
  /** 是否顯示 WOW 控制開關 */
  showWowPanel = false;

  constructor(
    private pageScrollService: PageScrollService,
    @Inject(DOCUMENT) private document: any,
    @Host() private hostElementRef: ElementRef,
    private templateService: TemplateService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.pageScrollInstance = this.pageScrollService.create({
        document: this.document,
        scrollTarget: this.hostElementRef.nativeElement,
        scrollOffset: 100,
        duration: 500
      });
    }
  }

  ngAfterViewChecked() {
    if (isPlatformBrowser(this.platformId)) {
      if (this.data.needScroll) {
        this.pageScrollService.start(this.pageScrollInstance);
        delete this.data.needScroll;
      }
    }
  }

  up() {
    this.templateService.keepConnection();
    this.templateService.moveSection(this.data.uuid, true);
    this.data.needScroll = true;
  }

  down() {
    this.templateService.keepConnection();
    this.templateService.moveSection(this.data.uuid, false);
    this.data.needScroll = true;
  }

  toggleEnable() {
    this.templateService.keepConnection();
    this.data.enable = !this.data.enable;
  }

  toggleWow() {
    this.templateService.keepConnection();
    this.showWowPanel = !this.showWowPanel;
  }

  addSection() {
    this.templateService.keepConnection();
    this.templateService.addSection(this.data.uuid);
  }

  rmSection() {
    this.templateService.keepConnection();
    this.templateService.rmSection(this.data.uuid);
  }
}
